export let dataProps = {
    id: 0,
    from_store_id: null,
    to_store_id: null,
    entry_date: new Date(),
    from_bank_id: null,
    to_bank_id: null,
    additional_notes: '',
    amount: 0,
    issued_to_staff_id: null,
    issued_by_staff_id: null
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreOrder/properties.js